// src/actions/actionTypes.js
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT = "LOGOUT";

export const FETCH_PAYMENT_OPTIONS_REQUEST = "FETCH_PAYMENT_OPTIONS_REQUEST";
export const FETCH_PAYMENT_OPTIONS_SUCCESS = "FETCH_PAYMENT_OPTIONS_SUCCESS";
export const FETCH_PAYMENT_OPTIONS_FAILURE = "FETCH_PAYMENT_OPTIONS_FAILURE";

export const FETCH_ALL_USERS_REQUESTS_REQUEST =
  "FETCH_ALL_USERS_REQUESTS_REQUEST";
export const FETCH_ALL_USERS_REQUESTS_SUCCESS =
  "FETCH_ALL_USERS_REQUESTS_SUCCESS";
export const FETCH_ALL_USERS_REQUESTS_FAILURE =
  "FETCH_ALL_USERS_REQUESTS_FAILURE";

export const FETCH_ALL_PAYMENT_REQUESTS_REQUEST =
  "FETCH_ALL_PAYMENT_REQUESTS_REQUEST";
export const FETCH_ALL_PAYMENT_REQUESTS_SUCCESS =
  "FETCH_ALL_PAYMENT_REQUESTS_SUCCESS";
export const FETCH_ALL_PAYMENT_REQUESTS_FAILURE =
  "FETCH_ALL_PAYMENT_REQUESTS_FAILURE";

export const FETCH_ALL_ORDER_REQUEST = "FETCH_ALL_ORDER_REQUEST";
export const FETCH_ALL_ORDER_SUCCESS = "FETCH_ALL_ORDER_SUCCESS";
export const FETCH_ALL_ORDER_FAILURE = "FETCH_ALL_ORDER_FAILURE";

export const FETCH_ALL_SIP_REQUEST = "FETCH_ALL_SIP_REQUEST";
export const FETCH_ALL_SIP_SUCCESS = "FETCH_ALL_SIP_SUCCESS";
export const FETCH_ALL_SIP_FAILURE = "FETCH_ALL_SIP_FAILURE";

export const FETCH_SIP_INSTALLMENT_REQUEST = "FETCH_SIP_INSTALLMENT_REQUEST";
export const FETCH_SIP_INSTALLMENT_SUCCESS = "FETCH_SIP_INSTALLMENT_SUCCESS";
export const FETCH_SIP_INSTALLMENT_FAILURE = "FETCH_SIP_INSTALLMENT_FAILURE";

export const FETCH_UNPAID_INSTALLMENT_REQUEST =
  "FETCH_UNPAID_INSTALLMENT_REQUEST";
export const FETCH_UNPAID_INSTALLMENT_SUCCESS =
  "FETCH_UNPAID_INSTALLMENT_SUCCESS";
export const FETCH_UNPAID_INSTALLMENT_FAILURE =
  "FETCH_UNPAID_INSTALLMENT_FAILURE";

export const FETCH_ALL_REWARD_REQUEST = "FETCH_ALL_REWARD_REQUEST";
export const FETCH_ALL_REWARD_SUCCESS = "FETCH_ALL_REWARD_SUCCESS";
export const FETCH_ALL_REWARD_FAILURE = "FETCH_ALL_REWARD_FAILURE";

export const FETCH_ALL_WORKING_INCOME_REQUEST =
  "FETCH_ALL_WORKING_INCOME_REQUEST";
export const FETCH_ALL_WORKING_INCOME_SUCCESS =
  "FETCH_ALL_WORKING_INCOME_SUCCESS";
export const FETCH_ALL_WORKING_INCOME_FAILURE =
  "FETCH_ALL_WORKING_INCOME_FAILURE";

export const FETCH_ALL_TEAM_GROW_INCOME_REQUEST =
  "FETCH_ALL_TEAM_GROW_INCOME_REQUEST";
export const FETCH_ALL_TEAM_GROW_INCOME_SUCCESS =
  "FETCH_ALL_TEAM_GROW_INCOME_SUCCESS";
export const FETCH_ALL_TEAM_GROW_INCOME_FAILURE =
  "FETCH_ALL_TEAM_GROW_INCOME_FAILURE";

export const FETCH_ALL_POWER_REQUEST = "FETCH_ALL_POWER_REQUEST";
export const FETCH_ALL_POWER_SUCCESS = "FETCH_ALL_POWER_SUCCESS";
export const FETCH_ALL_POWER_FAILURE = "FETCH_ALL_POWER_FAILURE";

export const FETCH_CAPPING_DATA_REQUEST = "FETCH_CAPPING_DATA_REQUEST";
export const FETCH_CAPPING_DATA_SUCCESS = "FETCH_CAPPING_DATA_SUCCESS";
export const FETCH_CAPPING_DATA_FAILURE = "FETCH_CAPPING_DATA_FAILURE";

export const APPROVE_REWARD_REQUEST_REQUEST = "APPROVE_REWARD_REQUEST_REQUEST";
export const APPROVE_REWARD_REQUEST_SUCCESS = "APPROVE_REWARD_REQUEST_SUCCESS";
export const APPROVE_REWARD_REQUEST_FAILURE = "APPROVE_REWARD_REQUEST_FAILURE";

export const REJECT_REWARD_REQUEST_REQUEST = "REJECT_REWARD_REQUEST_REQUEST";
export const REJECT_REWARD_REQUEST_SUCCESS = "REJECT_REWARD_REQUEST_SUCCESS";
export const REJECT_REWARD_REQUEST_FAILURE = "REJECT_REWARD_REQUEST_FAILURE";

export const FETCH_ALL_DUMMY_WALLET_REQUEST = "FETCH_ALL_DUMMY_WALLET_REQUEST";
export const FETCH_ALL_DUMMY_WALLET_SUCCESS = "FETCH_ALL_DUMMY_WALLET_SUCCESS";
export const FETCH_ALL_DUMMY_WALLET_FAILURE = "FETCH_ALL_DUMMY_WALLET_FAILURE";

export const APPROVE_PAYMENT_REQUEST_REQUEST =
  "APPROVE_PAYMENT_REQUEST_REQUEST";
export const APPROVE_PAYMENT_REQUEST_SUCCESS =
  "APPROVE_PAYMENT_REQUEST_SUCCESS";
export const APPROVE_PAYMENT_REQUEST_FAILURE =
  "APPROVE_PAYMENT_REQUEST_FAILURE";

export const REJECT_PAYMENT_REQUEST_REQUEST = "REJECT_PAYMENT_REQUEST_REQUEST";
export const REJECT_PAYMENT_REQUEST_SUCCESS = "REJECT_PAYMENT_REQUEST_SUCCESS";
export const REJECT_PAYMENT_REQUEST_FAILURE = "REJECT_PAYMENT_REQUEST_FAILURE";

export const FETCH_DASHBOARD_DATA_REQUEST = "FETCH_DASHBOARD_DATA_REQUEST";
export const FETCH_DASHBOARD_DATA_SUCCESS = "FETCH_DASHBOARD_DATA_SUCCESS";
export const FETCH_DASHBOARD_DATA_FAILURE = "FETCH_DASHBOARD_DATA_FAILURE";

export const FETCH_PAYMENT_TRANSACTIONS_REQUEST =
  "FETCH_PAYMENT_TRANSACTIONS_REQUEST";
export const FETCH_PAYMENT_TRANSACTIONS_SUCCESS =
  "FETCH_PAYMENT_TRANSACTIONS_SUCCESS";
export const FETCH_PAYMENT_TRANSACTIONS_FAILURE =
  "FETCH_PAYMENT_TRANSACTIONS_FAILURE";

export const SET_ACCOUNT_REQUEST = "SET_ACCOUNT_REQUEST";
export const SET_ACCOUNT_SUCCESS = "SET_ACCOUNT_SUCCESS";
export const SET_ACCOUNT_FAILURE = "SET_ACCOUNT_FAILURE";

export const RELEASED_INCOME_REQUEST = "RELEASED_INCOME_REQUEST";
export const RELEASED_INCOME_SUCCESS = "RELEASED_INCOME_SUCCESS";
export const RELEASED_INCOME_FAILURE = "RELEASED_INCOME_FAILURE";

export const FETCH_ALL_SLOTS_REQUEST = "FETCH_ALL_SLOTS_REQUEST";
export const FETCH_ALL_SLOTS_SUCCESS = "FETCH_ALL_SLOTS_SUCCESS";
export const FETCH_ALL_SLOTS_FAILURE = "FETCH_ALL_SLOTS_FAILURE";

export const UPDATE_SLOT_REQUEST = "UPDATE_SLOT_REQUEST";
export const UPDATE_SLOT_SUCCESS = "UPDATE_SLOT_SUCCESS";
export const UPDATE_SLOT_FAILURE = "UPDATE_SLOT_FAILURE";

export const SET_PROGRESS_MESSAGE = "SET_PROGRESS_MESSAGE";
export const SET_WARNING_MESSAGE = "SET_WARNING_MESSAGE";
export const SET_COMPLETED_MESSAGE = "SET_COMPLETED_MESSAGE";

export const SET_DISCONNECT_WALLET_REQUEST = "SET_DISCONNECT_WALLET_REQUEST";
export const SET_DISCONNECT_WALLET_SUCCESS = "SET_DISCONNECT_WALLET_SUCCESS";
export const SET_DISCONNECT_WALLET_FAILURE = "SET_DISCONNECT_WALLET_FAILURE";
